<template>
  <div class="goodsItem">
    <div @click="goToDetail(goodsItem)" style="cursor: pointer">
      <div class="imgContainer">
        <img :src="goodsItem.CommodityPicUrl" />
      </div>
      <div class="integral">
        <span class="num">{{
          goodsItem.Min_DetailIntegral | formatWithCommas(0)
        }}</span>
        <span
          v-if="goodsItem.Min_DetailIntegral && goodsItem.Max_DetailIntegral"
          class="split"
        >
          ~
        </span>
        <span class="num">{{
          goodsItem.Max_DetailIntegral | formatWithCommas(0)
        }}</span>
        <span class="txt">{{ $nextTick("PointsMall.Points") }}</span>
      </div>
      <div class="goods-title">{{ goodsItem.CommodityName }}</div>
      <!-- <div class="price_rest">
        <span>市场价 ￥{{ goodsItem.Price }}</span>
        <span>库存剩余 {{ goodsItem.Inventory }}</span>
      </div> -->
    </div>
    <!-- <button style="cursor: pointer" @click="conversion(goodsItem)">兑换</button> -->
  </div>
</template>

<script>
export default {
  // props: ["integral", "title", "price", "storage", "imgUrl"],
  props: {
    goodsItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    goToDetail(record) {
      console.log("跳转");
      this.$router.push({
        name: "productDetail",
        query: {
          pid: record.ID,
        },
      });
    },
    conversion(goodsItem) {
      this.$emit("conversion", goodsItem, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.goodsItem {
  .imgContainer {
    width: 220px;
    height: 220px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .integral {
    > span.num {
      color: #f96364;
      font-size: 22px;
      font-weight: 300;
      line-height: 30px;
      margin-right: 4px;
      margin-top: 6px;
    }
    > span.split {
      vertical-align: text-top;
    }
    > span.txt {
      font-size: 12px;
      font-weight: 400;
      color: #f96364;
      line-height: 17px;
    }
  }
  .goods-title {
    width: 220px;
    word-break: break-all;
    margin-top: 6px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #111827;
    line-height: 20px;
  }
  .price_rest {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #9ca3af;
      line-height: 17px;
    }
  }
  button {
    width: 100%;
    height: 30px;
    margin-top: 14px;
    background: #fff4f4;
    border-radius: 15px;
    border: 1px solid #ffe9e9;
  }
}
</style>
